import { CALL_TYPE_ID, COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID, MARKETING_EVENT_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { fromJS, OrderedSet } from 'immutable';
import FilterOperatorMultiStringInput from '../../../components/operator/FilterOperatorMultiStringInput';
import DisplayValueText from '../../../components/display/DisplayValueText';
import FilterDefinitionOwners from './FilterDefinitionOwners';
import makeAssociationField from './makeAssociationField';
import { COMPANY, CONTACT, DEAL, TICKET } from 'customer-data-objects/constants/ObjectTypes';
import once from 'transmute/once';
import I18n from 'I18n';
import { makeReferenceIdFieldDefinition } from 'customer-data-filters-ui/filterQueryFormat/fieldDefinitions/makeReferenceIdFieldDefinition';
import { MARKETING_EVENT_APP_NAMES } from 'reference-resolvers/constants/CacheKeys';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
import FilterOperatorInboundDbImportInput from '../../../components/operator/FilterOperatorInboundDbImportInput';
import DisplayValueInboundDbImport from '../../../components/display/DisplayValueInboundDbImport';
import { Map as ImmutableMap } from 'immutable';
const fieldDefinitionsByFilterFamily = {
  [COMPANY_TYPE_ID]: {
    hs_parent_company_id: makeAssociationField(COMPANY, COMPANY),
    hubspot_owner_id: FilterDefinitionOwners
  },
  [CONTACT_TYPE_ID]: {
    associatedcompanyid: makeAssociationField(COMPANY, CONTACT),
    hubspot_owner_id: FilterDefinitionOwners
  },
  [DEAL_TYPE_ID]: {
    'associations.contact': makeAssociationField(CONTACT, DEAL),
    'associations.company': makeAssociationField(COMPANY, DEAL),
    hubspot_owner_id: FilterDefinitionOwners
  },
  [TICKET_TYPE_ID]: {
    'associations.contact': makeAssociationField(CONTACT, TICKET),
    'associations.company': makeAssociationField(COMPANY, TICKET),
    hubspot_owner_id: FilterDefinitionOwners
  },
  [MARKETING_EVENT_TYPE_ID]: {
    hs_app_id: makeReferenceIdFieldDefinition({
      getLabelString: once(() => I18n.text('filterSidebar.fieldDefinitions.marketingEvents.appId')),
      referencedObjectType: MARKETING_EVENT_APP_NAMES
    })
  },
  [CALL_TYPE_ID]: {
    hs_created_by: makeReferenceIdFieldDefinition({
      getLabelString: once(() => I18n.text('recordProperties.activity_created_by')),
      referencedObjectType: ReferenceObjectTypes.USER
    })
  }
};
const fieldDefinitionsForAllObjects = {
  'associations.labeled': {
    operators: OrderedSet.of(Operators.AssociatedTo),
    referencedObjectType: ReferenceObjectTypes.CUSTOM_OBJECT
  },
  '_inbounddbio.importid_': {
    InputComponent: FilterOperatorInboundDbImportInput,
    ValueComponent: DisplayValueInboundDbImport
  },
  hs_merged_object_ids: {
    InputComponent: FilterOperatorMultiStringInput,
    ValueComponent: DisplayValueText
  }
};
export const getCRMSearchFieldDefinitionsForFilterFamily = filterFamily => {
  if (!filterFamily) {
    return ImmutableMap();
  }
  const fieldDefinitionsForFilterFamily = fieldDefinitionsByFilterFamily[filterFamily] || {};
  return fromJS(Object.assign({}, fieldDefinitionsForAllObjects, fieldDefinitionsForFilterFamily));
};